import EllipseBorder from "../../shapes/support/EllipseBorder";
import ImageCoordinate from "../../shapes/support/ImageCoordinate";
import RectangleHorizontalBorder from "../../shapes/support/RectangleHorizontalBorder";
import RectangleVerticalBorder from "../../shapes/support/RectangleVerticalBorder";
import RectCoordinate from "../../shapes/support/RectCoordinate";
import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import { ACTION_MAP, MOVE_IMAGE, RESHAPE } from "./ActionHelper";
import ReshapeEllipseAction from "./elements/ReshapeEllipseAction";
import ReshapePolyShapeAction from "./elements/ReshapePolyShapeAction";
import ReshapeRectangleAction from "./elements/ReshapeRectangleAction";
import MoveImageAction from "./image/MoveImageAction";
import ReshapeImageAction from "./image/ReshapeImageAction";

export default class ActionFactory extends AbstractProvidedClass {
    create(actionName, args) {
        switch (actionName) {
            case RESHAPE:
                return this.newReshapeAction(args[0]);

            case MOVE_IMAGE:
                return args[0] instanceof ImageCoordinate
                    ? new ReshapeImageAction(this.provider, args[0])
                    : new MoveImageAction(this.provider);

            default:
                return new ACTION_MAP[actionName](this.provider, ...args);
        }
    }

    newReshapeAction(elementPart) {
        switch (true) {
            case elementPart instanceof RectangleVerticalBorder:
            case elementPart instanceof RectangleHorizontalBorder:
            case elementPart instanceof RectCoordinate:
                return new ReshapeRectangleAction(this.provider, elementPart);

            case elementPart instanceof EllipseBorder:
                return new ReshapeEllipseAction(this.provider, elementPart);

            default:
                return new ReshapePolyShapeAction(this.provider, elementPart);
        }

    }
}
